import {
  // INIT_APP,
  // INIT_APP_SUCCESS,
  ERROR,
  SERVER_REQUEST,
} from "../constants";
import * as fromApp3 from "./app3";
import * as fromUser3 from "./user3";
import * as fromLocale3 from "./locale3";
import * as fromView3 from "./view3";
import * as fromForm3 from "./form3";
import * as fromData3 from "./data3";
import * as fromEvent3 from "./event3";
import * as fromEffect3 from "./effect3";
import * as fromPubSub3 from "./pubsub3";

// data3
export const loadDatasetv3 = (props) => fromData3.loadDatasetv3(props);
export const loadDatasetv3Success = (props) =>
  fromData3.loadDatasetv3Success(props);
export const unloadDatasetv3 = (props) => fromData3.unloadDatasetv3(props);
export const pub3 = (props) => fromData3.pub3(props);
export const subscribe3 = (props) => fromData3.subscribe3(props);
export const confirmPubSub3 = (props) => fromData3.confirmPubSub3(props);
export const clearPubSub3 = (props) => fromData3.clearPubSub3(props);

export const initUpload3 = (props) => fromData3.initUpload3(props);
export const initUpload3Success = (props) =>
  fromData3.initUpload3Success(props);
export const streamUpload3 = (props) => fromData3.streamUpload3(props);
export const streamUpload3Success = (props) =>
  fromData3.streamUpload3Success(props);
export const removeUpload3Success = (props) =>
  fromData3.removeUpload3Success(props);
export const finishUpload3 = (props) => fromData3.finishUpload3(props);
export const removeUploadv3 = (props) => fromData3.removeUploadv3(props);
export const download3 = (props) => fromData3.download3(props);

// pubsub
export const pubsub3FormDataUpdate = (props) =>
  fromPubSub3.pubsub3FormDataUpdate(props);
export const pubsub3NotificationCreate = (props) =>
  fromPubSub3.pubsub3NotificationCreate(props);

// event3
export const dispatchEvent3 = (props) => fromEvent3.dispatchEvent3(props);
export const dispatchEvent3Success = (props) =>
  fromEvent3.dispatchEvent3Success(props);

// app3
export const initApp3 = (props) => fromApp3.initApp3(props);
export const initApp3Connection = (props) => fromApp3.initApp3Connection(props);
export const initApp3ReadyClient = (props) =>
  fromApp3.initApp3ReadyClient(props);
export const initApp3ReadyServer = (props) =>
  fromApp3.initApp3ReadyServer(props);
export const initApp3Success = (props) => fromApp3.initApp3Success(props);
export const app3Offline = (props) => fromApp3.app3Offline(props);
export const socketDisconnect = (props) => fromApp3.socketDisconnect(props);

export const loadConfiguration3 = (props) => fromApp3.loadConfiguration3(props);
export const loadConfiguration3Success = (props) =>
  fromApp3.loadConfiguration3Success(props);
export const loadPublicConfiguration3 = (props) =>
  fromApp3.loadPublicConfiguration3(props);
export const error = (props) => fromApp3.error(props);
export const warning = (props) => fromApp3.warning(props);
export const confirmWarning = (props) => fromApp3.confirmWarning(props);
export const loadHTMLTemplate3Success = (props) =>
  fromApp3.loadHTMLTemplate3Success(props);
export const resumeTicket = (props) => fromApp3.resumeTicket(props);
export const clearResumeTicket = (props) => fromApp3.clearResumeTicket(props);
export const setPageTitle = (props) => fromApp3.setPageTitle(props);

export const setAppModalContent = (props) => fromApp3.setAppModalContent(props);

// user3
export const login3 = (props) => fromUser3.login3(props);
export const sign3 = (props) => fromUser3.sign3(props);
export const collect3 = (props) => fromUser3.collect3(props);
export const login3Success = (props) => fromUser3.login3Success(props);
export const login3Failed = (props) => fromUser3.login3Failed(props);
export const reconnect3 = (props) => fromUser3.reconnect3(props);
export const reconnect3Success = (props) => fromUser3.reconnect3Success(props);
// export const setTheme3 = props => fromUser3.setTheme3(props);
export const setUserPersistentProfile = (props) =>
  fromUser3.setUserPersistentProfile(props);
export const updateUserAttributes = (props) =>
  fromUser3.updateUserAttributes(props);
export const refreshToken3 = (props) => fromUser3.refreshToken3(props);
export const cancelLogin = (props) => fromUser3.cancelLogin(props);
export const loginSession = (props) => fromUser3.loginSession(props);
export const loginMetadata = (props) => fromUser3.loginMetadata(props);
export const signSession = (props) => fromUser3.signSession(props);

// locale
export const setLocale3 = (props) => fromLocale3.setLocale3(props);
export const loadLocale3 = (props) => fromLocale3.loadLocale3(props);
export const loadLocale3Success = (props) =>
  fromLocale3.loadLocale3Success(props);

// view
export const loadView3 = (props) => fromView3.loadView3(props);
export const loadView3Success = (props) => fromView3.loadView3Success(props);
export const saveView3 = (props) => fromView3.saveView3(props);
export const setQueryParams3 = (props) => fromView3.setQueryParams3(props);

// form
export const loadForm3 = (props) => fromForm3.loadForm3(props);
export const loadForm3Success = (props) => fromForm3.loadForm3Success(props);
export const loadForm3Fail = (props) => fromForm3.loadForm3Fail(props);
export const saveForm3 = (props) => fromForm3.saveForm3(props);
export const requestChangeStatus3 = (props) =>
  fromForm3.requestChangeStatus3(props);
export const changeStatus3 = (props) => fromForm3.changeStatus3(props);
export const changeStatus3Success = (props) =>
  fromForm3.changeStatus3Success(props);
export const setValidationError = (props) =>
  fromForm3.setValidationError(props);
export const requestForm3Section = (props) =>
  fromForm3.requestForm3Section(props);
export const setForm3Section = (props) => fromForm3.setForm3Section(props);
export const incForm3Section = (props) => fromForm3.incForm3Section(props);
export const addNote3 = (props) => fromForm3.addNote3(props);
export const uploadv3 = (props) => fromForm3.uploadv3(props);
export const closeForm3 = (props) => fromForm3.closeForm3(props);
export const unloadForm3 = (props) => fromForm3.unloadForm3(props);
export const setValidationMessage = (props) =>
  fromForm3.setValidationMessage(props);
export const confirmValidationMessage = (props) =>
  fromForm3.confirmValidationMessage(props);
export const setFormStop3 = (props) => fromForm3.setFormStop3(props);
export const resetZeroId = (props) => fromForm3.resetZeroId(props);

// effect
export const runEffect3 = (props) => fromEffect3.runEffect3(props);
export const runEffect3Success = (props) =>
  fromEffect3.runEffect3Success(props);
export const unloadEffect3 = (props) => fromEffect3.unloadEffect3(props);

//
// PUT NEW ACTIONS HERE (v3 actions)
//
/**
 * InitApp
 *
 * @param  {json} payload - contains the menus
 *
 * @return {object}      An action object with a type of LOAD_MENU_SUCCESS
 */
// export function _initApp({fromLogin = false}) {
//   return {
//     type: INIT_APP,
//     fromLogin
//   };
// }

// export function _initAppSuccess({user}) {
//   return {
//     type: INIT_APP_SUCCESS,
//     user
//   };
// }

/**
 * @desc Broadcast a general error
 *
 * @param data - data for error. Should at least contain:
 *   data.errorMsg - Error Message to be displayed
 * @return {json} - redux
 *
 */
export const _error = (data, _id) => {
  return {
    type: ERROR,
    data: data,
    _id: _id,
  };
};

/**
 * Send a request to the server
 *
 * @return {object} An action object with a type of LOAD_REPOS
 */
export function serverRequest(payload) {
  return {
    type: SERVER_REQUEST,
    payload: payload,
  };
}
